import React, {useState} from 'react';
import PropTypes from 'prop-types'
import stylesCSS from './Tooltip.scss';
import {usePopper} from "react-popper";
import {__t} from "../lang/text-resource";


const Tooltip = (props) => {


	const [referenceElement, setReferenceElement] = useState(null);
	const [popperElement, setPopperElement] = useState(null);
	const [arrowElement, setArrowElement] = useState(null);
	const {styles, attributes} = usePopper(referenceElement, popperElement, {
		placement: 'top',
		modifiers: [
			{
				name: 'arrow',
				options: {
					element: arrowElement
				}
			},
			{
				name: 'offset',
				options: {
					offset: [0, 15],
				},
			}
		],
	});


	const classNames = [];
	classNames.push(stylesCSS.tooltip);

	if (props.showOnlyWithClick) {
		classNames.push(stylesCSS.onlyWithClick)
	}
	if (props.wider) {
		classNames.push(stylesCSS.wider)
	}


	const onClick = () => {
		if (popperElement) {
			if (popperElement.style.visibility === 'visible') {
				popperElement.style.visibility = 'hidden';
			} else {
				popperElement.style.visibility = 'visible';
			}
		}
	}

	return (
	  <div className={classNames.join(' ')}>
			<span ref={setReferenceElement} onClick={onClick}>
				{!!props.tooltipImg && <img src={props.tooltipImg} alt={__t('More')}/>}
				{!props.tooltipImg && (
				  <svg fill="#3063d1" xmlns="https://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
					  <g fill="#3063d1">
						  <g transform="translate(-92 -19)">
							  <g fill="#3063d1" transform="translate(92 19)">
								  <path
									d="M5.5 11C2.467 11 0 8.533 0 5.5S2.467 0 5.5 0 11 2.467 11 5.5 8.533 11 5.5 11zM5.5.89C2.958.89.89 2.959.89 5.5c0 2.542 2.068 4.61 4.61 4.61 2.542 0 4.61-2.068 4.61-4.61C10.11 2.958 8.041.89 5.5.89z"/>
								  <path
									d="M5.5 4.789c-.369 0-.613.299-.613.668v3.108h1.226V5.457c0-.37-.244-.668-.613-.668z"/>
								  <circle cx="5.5" cy="3.301" r="1"/>
							  </g>
						  </g>
					  </g>
				  </svg>
				)}
			</span>
		  <div className={stylesCSS.content} ref={setPopperElement} style={styles.popper} {...attributes.popper}>
			  <div className={stylesCSS.text}>
				  {props.children.length > 0 ? props.children : props.tooltip}
			  </div>
			  <div ref={setArrowElement} style={styles.arrow} className={stylesCSS.arrow}/>
		  </div>
	  </div>
	);
}

Tooltip.defaultProps = {
	children: []
}
Tooltip.propTypes = {
	tooltip: PropTypes.string,
	children: PropTypes.node,
	showOnlyWithClick: PropTypes.bool,
	wider: PropTypes.bool,
	alignRight: PropTypes.bool,
	bottomPosition: PropTypes.bool,
	tooltipImg: PropTypes.string
}

export default Tooltip;
